import { createContext, useEffect, useState } from "react"
import { decodeToken } from "data/users"

interface UserI {
    token: string;
    isAdmin: boolean;
    permissions: string[];
}

interface UserContextI {
    user: UserI,
    setUserInfo: (payload: Omit<UserI, 'permissions'>) => void
}

export const UserContext = createContext({} as UserContextI);

const initialState: UserI = {
    token: '',
    isAdmin: false,
    permissions: [],
}

function buildUser(stored: { token: string; isAdmin: boolean }): UserI {
    const identity = decodeToken()
    return {
        ...stored,
        permissions: identity?.permissions ?? [],
    }
}

const UserContextProvider = ({children}: any) => {
    const [user, setUser] = useState<UserI>(initialState);

    useEffect(() => {
        const stored = localStorage.getItem('@appUser')
        if (stored) {
            setUser(buildUser(JSON.parse(stored)))
        }
    }, [])

    const setUserInfo = (payload: Omit<UserI, 'permissions'>) => {
        localStorage.setItem('@appUser', JSON.stringify(payload));
        setUser(buildUser(payload))
    }

    return (
        <UserContext.Provider value={{ user, setUserInfo }}>
            {children}
        </UserContext.Provider>
    )
}

export default UserContextProvider
